// extracted by mini-css-extract-plugin
export var ourBenefits = "index-module--ourBenefits--2RxtA";
export var title = "index-module--title--17X3p";
export var figures = "index-module--figures--21sip";